import { makeStyles } from '@mui/styles';
import { ApplicationMuiTheme } from '@tassat/payments-themes/dist/types/theme';

export const muiStyles = makeStyles((theme: ApplicationMuiTheme) => ({
    fullWidth: {
        width: '100%',
        alignSelf: 'center' as 'center'
    },
    flexColumn: {
        display: 'flex',
        flexFlow: 'column nowrap'
    },
    submitButtonContainer: {
        marginTop: '0.5rem',
        marginBottom: '0.5rem'
    },
    submitButton: { width: 'auto' as 'auto' },
    submitError: { alignSelf: 'center' }
}));